import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { Box } from "@chakra-ui/react";

import Layout from "../components/Layout";

const Apicuron = (props) => {
    useEffect(() => {
        const element = document.querySelector('apicuron-leaderboard[resource]')
        if (element) {
            element.options = [['total-leaderboard', ['Ranking', 'Contributor', 'Generation Contributions']], 'weekly-leaderboard']
        }
    }, [])

    return (
        <Layout>
            <Box padding="100px">
                <apicuron-leaderboard resource="micropub"></apicuron-leaderboard>
            </Box>
            <Helmet>
                <script src="https://apicuron.org/assets/widgets/apicuron-leaderboard.js"></script>
            </Helmet>
        </Layout>
    );
};

export default Apicuron;
